import React, { Component } from 'react';
import Language from '../Language';
import DarkModeToggle from '../DarkModeToggle';
import { withTranslation } from 'react-i18next';
import helper from '../../../utils/helper';

class Shortcuts extends Component {
  toggleBodyClass() {
    document.body.classList.toggle('content-side-open');
  }

  render() {
    const { t } = this.props;
    return (
      // <div className="shortcuts">
      <div className="d-flex">
        <DarkModeToggle />
        {!helper.isMobile() && (
          <a className="shortcut-item">
            <Language />
          </a>
        )}
        <a className="shortcut-item" onClick={this.toggleBodyClass.bind(this)}>
          <i className="md-icon">menu</i>
          <span>{t('Menu')}</span>
        </a>
      </div>
    );
  }
}

export default withTranslation('app')(Shortcuts);
